const Categories = [
  {
    id: 2,
    categories: "web apps",
    name: "Movie Today",
    img: "./images/movies.png",
    description:
      "A Web App that displays movies and tv shows with their trailers ",
    languages: ["Javascript", "ReactJS"],
    link: "https://movies-today.vercel.app/",
    github: "https://github.com/kayodeolowo",
    data: "Rest Api",
  },

  {
    id: 132,
    categories: "websites",
    name: "RoyalField Consulting",
    img: "./images/royalf.png",
    languages: ["Javascript", "ReactJS"],
    link: "https://www.royalfieldconsulting.com/",
    github: "https://github.com/kayodeolowo?tab=repositories",
    data: "Json",
  },

  // {
  //   id: 20,
  //   categories: "websites",
  //   name: "MetaAfrica Sports",
  //   img: "./images/metaafrica.png",
  //   languages: ["Typescript", "NextJS"],
  //   link: "https://metaafricasports.com/",
  //   github: "https://github.com/kayodeolowo?tab=repositories",
  //   data: "Api"

  // },

  {
    id: 1,
    categories: "web apps",
    name: "Crypto Stats",
    img: "./images/cryptostats.png",
    description:
      " Web App were users can check different Live crypto currencies with their individual data ",
    languages: ["Typescript", "NextJS"],
    link: "https://crypto-chart-stats.vercel.app/",
    github: "https://github.com/kayodeolowo",
    data: "Rest Api",
  },

  {
    id: 223,
    categories: "web apps",
    name: "Novasyra",
    img: "./images/nova.png",
    description:
      "A Web App that displays movies and tv shows with their trailers ",
    languages: ["Typescript", "ReactJS"],
    link: "https://novasyra.vercel.app/",
    github: "https://github.com/kayodeolowo",
    data: "Rest Api",
  },

  {
    id: 50,
    categories: "web apps",
    name: "Biosphere Solutions",
    img: "./images/bio.png",
    languages: ["Javascript", "NextJS"],
    link: "https://biospheresolutions.netlify.app/",
    github: "https://github.com/kayodeolowo?tab=repositories",
    data: "Json",
  },

  {
    id: 14,
    categories: "web apps",
    name: "Marketie",
    img: "./images/dashboard.jpg",
    description:
      "Sales dashboard that provides real-time details on sales performance, Earnings, top-selling products and others ",
    languages: ["Javascript", "ReactJS"],
    link: "https://sales-dahsboard.netlify.app/dashboard",
    github: "https://github.com/kayodeolowo?tab=repositories",
    data: "Json",
  },

  // {
  //   id: 15,
  //   categories: "web apps",
  //   name: "Moon Republic",
  //   img: "./images/moonrep.jpg",
  //   languages: ["Javascript", "ReactJS"],
  //   link: "https://moonrepublic.netlify.app/",
  //   github: "https://github.com/kayodeolowo?tab=repositories",
  //   data: "Json"

  // },

  {
    id: 13,
    categories: "web apps",
    name: "KrayaStores",
    img: "./images/ecom.png",
    description: "An E-commerce website for shopping ",
    languages: ["Typescript", "ReactJS"],
    link: "https://krayastores.netlify.app/",
    github: "https://github.com/kayodeolowo/e-commerce",
    data: "Rest Api",
  },

  {
    id: 16,
    categories: "web apps",
    name: "  Begreat Finance",
    img: "./images/begreat.jpg",
    languages: ["Javascript", "Next JS"],
    link: "https://be-great-finance.netlify.app",
    github: "https://github.com/kayodeolowo?tab=repositories",
    data: "Json",
  },

  // {
  //   id: 4,
  //   categories: "websites",
  //   name: "Ms lockdown",
  //   img: "./images/mslockdown.png",
  //   description: "Website built for a social media Startup ",
  //   languages: ["Javascript", "ReactJS"],
  //   link: "https://mslockdown.netlify.app/",
  //   github: "https://github.com/kayodeolowo?tab=repositories",
  // },

  {
    id: 12,
    categories: "websites",
    name: "ArbFurbo",
    img: "./images/arb.jpg",
    description:
      "Web 3 web app that operates on top of a decentralized network and utilizes blockchain technology",
    languages: ["Javascript", "NextJS"],
    link: "https://arbfurbo-k35z.vercel.app/",
    github: "https://github.com/kayodeolowo?tab=repositories",
  },

  {
    id: 9,
    categories: "web apps",
    name: "My Portfolio",
    type: "Json",
    img: "./images/port.png",
    description: "Hi Welcome to my portfolio. ",
    languages: ["Javascript", "ReactJS"],
    link: "https://kayodeolowo.netlify.app/",
    github: "https://github.com/kayodeolowo/myportfolio",
    data: "JSon",
  },
];

export default Categories;
